import React from "react";
import FlexBox from "components/FlexBox/FlexBox";
import Skeleton from "@mui/material/Skeleton";
import { Grid } from "@mui/material";
import { css } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { range } from "lodash";

type Props = {
  numberOfRows?: number;
  numberOfColumns?: number;
};

const ApplicationSearchTableLoading: React.FC<Props> = ({ numberOfRows = 4, numberOfColumns = 6 }) => {
  return (
    <StyledContainer container data-testid={"ApplicationSearchTableLoading"}>
      {range(0, numberOfRows).map((i) => (
        <Row key={i} container>
          {range(0, numberOfColumns).map((i) => (
            <Grid item xs={2} key={i}>
              <SkeletonWrapper>
                <Skeleton variant="rectangular" height={22} />
              </SkeletonWrapper>
            </Grid>
          ))}
        </Row>
      ))}
    </StyledContainer>
  );
};

const SkeletonWrapper = styled(FlexBox)(
  ({ theme }) => css`
    display: flex;
    height: 100%;
    justify-content: center;
    flex-direction: column;
    padding: ${theme.spacing(3)};
  `
);

const Row = styled(Grid, { shouldForwardProp: (prop) => prop !== "$isHeader" })<{ $isHeader?: boolean }>(
  ({ theme, $isHeader }) => css`
    border-bottom: 1px solid ${theme.palette.grey[300]};
    ${!$isHeader &&
    css`
      height: 62px;
    `}

    &:last-child {
      border-bottom: 0;
    }
  `
);

const StyledContainer = styled(Grid)(
  ({ theme }) => css`
    border: 1px solid ${theme.palette.grey[300]};
  `
);

export default ApplicationSearchTableLoading;
